module.exports = __webpack_public_path__ + "static/media/choose-network.9ae4f7a9.png";